import React, { useState } from 'react';
import { DialogComponent, Tables } from '../../../../../../Components';
import { TableActions } from '../../../../../../Enums';
import EntityRevenueFields from './EntityRevenueFields';
import { ButtonBase } from '@material-ui/core';
import DeleteEntityDialog from './DeleteEntityDialog';
import { showError } from '../../../../../../Helper';
import {
  DeleteEntityCommissionSetting,
  UpdateEntityCommissionSetting,
} from '../../../../../../Services/LeadXChangeServices/LeadXChangeServices';

const headerData = [
  { label: 'Entity', input: 'systemSourceName' },
  {
    label: 'Commission Type',
    component: (item) =>
      item.commissionType === 2 ? 'Percentage (%)' : 'Fixed Amount (AED)',
  },
  { label: 'Commission', input: 'commissionValue' },
];

export default function EntityRevenueTable({
  parentTranslationPath,
  translate,
  entityCommission,
  setState,
  state,
  selectedValue,
  setSelectedValue,
  entitySources,
  reload,
}) {
  const [editEntity, setEditEntity] = useState(null);
  const [activeItem, setActiveItem] = useState(null);
  const [deleteEntity, setDeleteEntity] = useState(null);

  const onActionClicked = (actionEnum, item) => {
    if (actionEnum === TableActions.edit.key) {
      setActiveItem(item);
      setEditEntity(true);
    }
    if (actionEnum === TableActions.delete.key) {
      setActiveItem(item);
      setDeleteEntity(true);
    }
  };

  const handleCloseDialog = () => {
    setEditEntity(false);
    setActiveItem(null);
    setSelectedValue({
      entitySource: {},
      commissionType: null,
      commissionValue: '',
    });
  };

  const handleSaveChanges = async () => {
    try {
      await UpdateEntityCommissionSetting(state);
      reload();
    } catch {
      showError('failed to update entity revenue share.');
    }
  };

  const handleDeleteEntity = async (activeItem) => {
    const id = activeItem.entityCommissionSettingId;
    try {
      await DeleteEntityCommissionSetting(id);
      reload();
    } catch {
      showError('failed to delete entity revenue share.');
    }
  };

  return (
    <div className='w-50'>
      <Tables
        data={entityCommission}
        headerData={headerData}
        defaultActions={[
          { enum: TableActions.edit.key },
          { enum: TableActions.delete.key },
        ]}
        actionsOptions={{ onActionClicked }}
        parentTranslationPath={parentTranslationPath}
        activePage={0}
      />
      {editEntity && (
        <DialogComponent
          isOpen
          titleText={'Edit entity revenue share'}
          maxWidth={'sm'}
          onCloseClicked={handleCloseDialog}
          wrapperClasses={'entity-dialog-wrapper'}
          parentTranslationPath={parentTranslationPath}
          dialogContent={
            <div className='entity-dialog-content'>
              <EntityRevenueFields
                parentTranslationPath={parentTranslationPath}
                translate={translate}
                entitySources={entitySources}
                setState={setState}
                state={state}
                selectedValue={selectedValue}
                setSelectedValue={setSelectedValue}
                activeItem={activeItem}
                entityCommission={entityCommission}
              />
            </div>
          }
          dialogActions={
            <div className='entity-dialog-actions'>
              <ButtonBase
                className='btns theme-propx outlined'
                onClick={handleCloseDialog}
              >
                Cancel
              </ButtonBase>
              <ButtonBase
                className='btns theme-propx solid'
                onClick={() => {
                  handleSaveChanges();
                  setEditEntity(false);
                  setActiveItem(null);
                }}
              >
                Save changes
              </ButtonBase>
            </div>
          }
        />
      )}

      {deleteEntity && (
        <DeleteEntityDialog
          isOpen
          parentTranslationPath={parentTranslationPath}
          onClose={() => {
            setDeleteEntity(false);
            setActiveItem(null);
          }}
          activeItem={activeItem}
          handleDeleteFunction={handleDeleteEntity}
        />
      )}
    </div>
  );
}
